import { Editor } from "@tiptap/vue-2";

import StarterKit from "@tiptap/starter-kit";
import Underline from "@tiptap/extension-underline";
import TextAlign from "@tiptap/extension-text-align";
import Highlight from "@tiptap/extension-highlight";
import Table from "@tiptap/extension-table";
import TableRow from "@tiptap/extension-table-row";
import TableCell from "@tiptap/extension-table-cell";
import TableHeader from "@tiptap/extension-table-header";
import Image from "@tiptap/extension-image";

import EmbedInlineData from "@/components/editorExtensions/EmbedInlineDataExtension";
import EmbedBlockData from "@/components/editorExtensions/EmbedBlockDataExtension";
import EmbedDocument from "@/components/editorExtensions/EmbedDocumentExtension";
// import BoxValue from "@/components/editorExtensions/inputFields/BoxValueExtension";
// import DateInput from "@/components/editorExtensions/inputFields/DateInputExtension";
// import FileInput from "@/components/editorExtensions/inputFields/FileInputExtension";
// import NumberInput from "@/components/editorExtensions/inputFields/NumberInputExtension";
// import TextInput from "@/components/editorExtensions/inputFields/TextInputExtension";
import InputField from "@/components/editorExtensions/InputFieldExtension";

export default function GluidTipTapEditorInstance(
  contentEditable,
  contentAutofocus
) {
  const editor = new Editor({
    extensions: [
      StarterKit,
      Image,
      Underline,
      TextAlign,
      Highlight,
      Table,
      TableHeader,
      TableCell,
      TableRow,
      // BoxValue,
      // DateInput, 
      // NumberInput, 
      // FileInput, 
      // TextInput,
      InputField,
      EmbedInlineData,
      EmbedBlockData,
      EmbedDocument
    ],
    autofocus: contentAutofocus,
    editable: contentEditable,
    editorProps: {
      attributes: {
        class:
          "prose prose-sm sm:prose lg:prose-lg xl:prose-2xl mx-auto focus:outline-none"
      }
    }
  });
  return editor;
}
